export const getImageUrl = (product: { [K: string]: any }): string => {
  return product.images && product.images.length > 0
    ? product.images[product.images.length - 1].url
    : '';
};
